export class LabParameterMethod {
    labParameterMethodId: number;
    methodName: string;
}